import { InjectionToken } from '@angular/core';
import { KeystrokeReportsPort } from './keystroke-reports.port';

export const KEYSTROKE_REPORTS_PORT = new InjectionToken<KeystrokeReportsPort>('KEYSTROKE_REPORTS_PORT');

